import { FC } from "react";
import { Path, Svg } from "react-native-svg";
import { tSvgProps } from "../types";

const PdChevronUp: FC<tSvgProps> = (props) => (
  <Svg viewBox="0 0 7 4" fill="none" {...props}>
    <Path
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      focusable={false}
      d="M3.5 0 7 3.5V4h-.5l-3-3-3 3H0v-.5L3.5 0Z"
      fill="currentColor"
    />
  </Svg>
);

export default PdChevronUp;
